import React from 'react';
import { Shield, Lock, Server } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function TrustSection() {
  const {
    t
  } = useLanguage();
  return <section className="bg-brand-green text-white relative overflow-hidden" data-id="element-319">
      {/* Subtle texture */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff03_1px,transparent_1px),linear-gradient(to_bottom,#ffffff03_1px,transparent_1px)] bg-[size:48px_48px] pointer-events-none" data-id="element-320" />
      {/* Gold glow top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-px bg-gradient-to-r from-transparent via-brand-gold/40 to-transparent" data-id="element-321" />

      {/* Main green content */}
      <div className="py-16 md:py-24 lg:py-40" data-id="element-322">
        <div className="container mx-auto px-4 sm:px-6 md:px-8 relative z-10" data-id="element-323">
          <div className="text-center max-w-3xl mx-auto mb-12 md:mb-24" data-id="element-324">
            <p className="text-brand-gold/70 font-semibold text-xs uppercase tracking-widest mb-4" data-id="element-325">
              {t.trust.label}
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 tracking-tight font-heading" data-id="element-326">
              {t.trust.headline}
            </h2>
            <p className="text-white/65 text-lg leading-relaxed" data-id="element-327">
              {t.trust.subtitle}
            </p>
          </div>

          {/* Big Stats */}
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-12 text-center mb-12 md:mb-24 border-b border-white/10 pb-12 md:pb-24" data-id="element-328">
            {t.trust.stats.map((stat, idx) => <div key={idx} className="border-t border-white/10 pt-6 md:pt-8" data-id="element-329">
                <div className="text-4xl md:text-5xl font-bold text-brand-gold mb-2 tracking-tight tabular-nums font-heading" data-id="element-330">
                  {stat.value}
                </div>
                <div className="text-xs text-white/50 font-medium uppercase tracking-wider" data-id="element-331">
                  {stat.label}
                </div>
              </div>)}
          </div>

          {/* Pillars — white/10 glass style to match green bg */}
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6" data-id="element-332">
            {[{
            icon: <Shield className="w-7 h-7 text-brand-gold" data-id="element-333" />,
            idx: 0
          }, {
            icon: <Lock className="w-7 h-7 text-brand-gold" data-id="element-334" />,
            idx: 1
          }, {
            icon: <Server className="w-7 h-7 text-brand-gold" data-id="element-335" />,
            idx: 2
          }].map(({
            icon,
            idx
          }) => <div key={idx} className="p-8 bg-white/10 border border-white/15 rounded-2xl hover:bg-white/15 transition-all" data-id="element-336">
                <div className="mb-5" data-id="element-337">{icon}</div>
                <h3 className="text-lg font-bold text-white mb-3 font-heading" data-id="element-338">
                  {t.trust.pillars[idx].title}
                </h3>
                <p className="text-white/60 text-sm leading-relaxed" data-id="element-339">
                  {t.trust.pillars[idx].desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}